<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>{{ isFr ? 'Acheter des USDT' : 'Buy USDT' }}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close(true)">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="bm-body">

    <!-- Stats de l'offre -->
    <div class="bm-stats">
      <div class="bm-stat">
        <span class="bm-stat__label">{{ isFr ? 'Taux' : 'Rate' }}</span>
        <span class="bm-stat__value">{{ p2p.fromRateUnits(order.rate) }}</span>
        <span class="bm-stat__unit">{{ order.currency }}</span>
      </div>
      <div class="bm-stat-sep"></div>
      <div class="bm-stat">
        <span class="bm-stat__label">{{ isFr ? 'Dispo' : 'Available' }}</span>
        <span class="bm-stat__value">{{ p2p.fromWei(order.remaining) }}</span>
        <span class="bm-stat__unit">USDT</span>
      </div>
      <div class="bm-stat-sep"></div>
      <div class="bm-stat">
        <span class="bm-stat__label">{{ isFr ? 'Minimum' : 'Min' }}</span>
        <span class="bm-stat__value">{{ p2p.fromWei(order.minBuy) }}</span>
        <span class="bm-stat__unit">USDT</span>
      </div>
    </div>

    <!-- Champ montant -->
    <div class="bm-input-wrap">
      <div class="bm-input-label">{{ isFr ? 'Montant' : 'Amount' }}</div>
      <div class="bm-input-row">
        <ion-input class="bm-input"
          type="number" inputmode="decimal"
          [(ngModel)]="amount"
          [min]="min" [max]="max"
          [placeholder]="isFr ? 'ex: ' + min : 'eg. ' + min">
        </ion-input>
        <span class="bm-input-unit">USDT</span>
      </div>
      <div class="bm-input-hint" *ngIf="parsedAmount > 0 && parsedAmount < min">
        <ion-icon name="alert-circle-outline"></ion-icon>
        {{ isFr ? 'Minimum : ' : 'Minimum: ' }}{{ min }} USDT
      </div>
      <div class="bm-input-hint" *ngIf="parsedAmount > max">
        <ion-icon name="alert-circle-outline"></ion-icon>
        {{ isFr ? 'Maximum : ' : 'Maximum: ' }}{{ max }} USDT
      </div>
    </div>

    <!-- Ce que l'acheteur paie -->
    <div class="bm-payable" *ngIf="parsedAmount > 0">
      <div class="bm-payable__left">
        <ion-icon name="cash-outline"></ion-icon>
        <span>{{ isFr ? 'Vous payez' : 'You pay' }}</span>
      </div>
      <span class="bm-payable__value">{{ buyerPays(amount) }} {{ order.currency }}</span>
    </div>

    <!-- Actions -->
    <div class="bm-actions">
      <ion-button expand="block" fill="outline" color="medium" shape="round"
        class="bm-btn bm-btn--cancel" (click)="close(true)">
        {{ isFr ? 'Annuler' : 'Cancel' }}
      </ion-button>
      <ion-button expand="block" color="secondary" shape="round"
        class="bm-btn" (click)="confirm()"
        [disabled]="!amount || parsedAmount < min || parsedAmount > max">
        {{ isFr ? 'Confirmer' : 'Confirm' }}
      </ion-button>
    </div>

  </div>
</ion-content>
